<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Compras asignadas</h3>
            </div>
        </div>
        <div class="table-responsive">
            <table>
                <thead>
                    <tr>
                        <th>Número de documento</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="compra in compras" :key="compra.id">
                        <td>
                            {{ compra.numero }}
                        </td>
                        <td>
                            <button @click="verDocumento(compra)" type="button" class="btn-info btn--text">
                                <i class="fa fa-eye"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-buttons">
            <button @click="$emit('cerrar')" class="btn-danger btn--text" type="button">
                <i class="fa fa-ban"></i><span>Cerrar</span>
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        compras: {
            type: Array,
            required: false,
            default: function () {
                return [];
            }
        }
    },
    methods: {
        verDocumento: function (row) {
            window.open(url + '/compras/' + row.id + '/edit', '_blank');
        }
    }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/comprobantes/ComprasAsignadas.vue